<div class="guts-p-b-3 guts-p-t-1">
  <div class="border rounded oh">
    <div class="l_flex guts-p-full-3 m-guts-p-full-1 rel l_flex-justify-center">
      <div class="guts-p-r-2 m-guts-p-b-1 m-guts-p-r-0">
        <div class="tip__logo rel">
          <img [src]="degreedLogo" class="tip__logo-img abs-center" alt="" />
        </div>
      </div>
      <div>
        <p
          class="par tip__message"
          [innerHTML]="i18n.dgSkillsCheckup_message"
        ></p>
        <div class="guts-m-t-1">
          <button
            class="guts-m-r-1"
            df-button
            dfButtonType="primary"
            (click)="updateRatings()"
            [textContent]="i18n.dgSkillsCheckup_UpdateRatings"
            data-dgat="tips-54f"
          ></button>
          <button
            df-button
            dfButtonType="secondary"
            (click)="doneRating()"
            [textContent]="i18n.dgSkillsCheckup_DoneRating"
            data-dgat="tips-54f"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
